import DynamicLoad from '../common/js/dynamicLoad';
import RuntimeUtils from '../common/js/runtimeUtils';
import { getJobType } from 'src/utils/jobUtils';
import { analysisFileType } from 'src/utils/commonUtils';

export class ModelDocumentUtils {
    obvDocument = '';
    async init(token, urn, fileInfo) {
        await this._loadObvJs();
        const build = new OBV.Api.ObvBuilder();
        const applicationOptions = {
            getAccessToken(cb) {
                cb(token, 60000);
            },
            serviceConfig: {
                origin: `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}`,
                apiContextPath: RuntimeUtils.instance.servicePath,
            },
            viewer3dConfig: {},
        };
        const application = await build.buildApplication(applicationOptions);
        if (fileInfo.convertType === 'obv') {
            // TODO 已知的问题，如果获取视图失败，无法捕获异常
            this.obvDocument = await build.loadDocument(application, urn);
        } else if (fileInfo.convertType === 'lod') {
            const jobType = await getJobType(analysisFileType(fileInfo.fileName), 'lod');
            if (jobType) {
                this.obvDocument = await build.loadDocument(application, urn, jobType);
            } else {
                this.obvDocument = null;
            }
        }
    }

    getViewableItems(isFilter = false) {
        let list = [];
        if (this.obvDocument) {
            list = this.obvDocument.getViewableItems(this.obvDocument.getRootItem());
        }
        if (!isFilter) {
            return list;
        }
        return list.map((folder) => {
            if (folder.children && folder.children.length > 0) {
                const children = folder.children.map((item) => {
                    return {
                        ...item,
                        children: undefined,
                    };
                });
                return {
                    ...folder,
                    children,
                };
            } else {
                return {
                    ...folder,
                };
            }
        });
    }

    get3dGeometryItems(item) {
        return this.obvDocument.get3dGeometryItems(item);
    }

    get2dGeometryItems(item) {
        return this.obvDocument.get2dGeometryItems(item);
    }

    _loadObvJs() {
        DynamicLoad.loadCss(RuntimeUtils.instance.obvCssPath);
        DynamicLoad.loadResourceLink(RuntimeUtils.instance.obvPropertiesPath);
        return DynamicLoad.loadJs(RuntimeUtils.instance.obvJsPath);
    }
}

// 获取obvDocument
export const getModelDocument = async (token, fileInfo) => {
    // 初始化obvjs，区分新旧数据
    await DynamicLoad.loadJs(RuntimeUtils.instance.obv5JsPath);
    const build = new OBV.Api.ObvBuilder();
    const applicationOptions = {
        getAccessToken(cb) {
            cb(token, 60000);
        },
        serviceConfig: {
            origin: `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}`,
            apiContextPath: RuntimeUtils.instance.servicePath,
        },
        viewer3dConfig: {},
    };
    const application = await build.buildApplication(applicationOptions);
    let obvDocument = null;
    if (fileInfo.convertType === 'obv') {
        obvDocument = await build.loadDocument(application, fileInfo.urn);
    } else if (fileInfo.convertType === 'lod') {
        obvDocument = await build.loadDocument(application, fileInfo.urn, fileInfo.jobType);
    }
    return obvDocument;
};



// WEBPACK FOOTER //
// ./src/utils/ModelDocumentUtils.js